'use client'
import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__IconButton_index_js_793c8d01__ from "../../IconButton/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__Calendar_Calendar_variants_js_f4a68d75__ from "../Calendar/Calendar.variants.js";
function PreviousMonthButton(props) {
    const { buttonPrevious, buttonPreviousContainer } = (0, __WEBPACK_EXTERNAL_MODULE__Calendar_Calendar_variants_js_f4a68d75__.calendarVariants)();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: buttonPreviousContainer(),
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__IconButton_index_js_793c8d01__.IconButton, {
            ...props,
            className: buttonPrevious(),
            iconName: "chevron_left",
            type: "plainPrimary",
            size: "sm"
        })
    });
}
function NextMonthButton(props) {
    const { buttonNext, buttonNextContainer } = (0, __WEBPACK_EXTERNAL_MODULE__Calendar_Calendar_variants_js_f4a68d75__.calendarVariants)();
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: buttonNextContainer(),
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__IconButton_index_js_793c8d01__.IconButton, {
            ...props,
            className: buttonNext(),
            iconName: "chevron_right",
            type: "plainPrimary",
            size: "sm"
        })
    });
}
export { NextMonthButton, PreviousMonthButton };
